<template>
  <div style="width: 100%">
    <v-autocomplete
      class="tema-eixo-combo"
      id="temas-select"
      v-model="filter.municipioId"
      item-text="nome"
      filled
      item-name="nome"
      item-value="municipioId"
      :items="municipios"
      label="Municípios"
      placeholder="Selecione um lugar"
      v-on:change="$emit('onChange')"
      :disabled="disabled"
      :multiple="multiple"
      clearable
      :rules="rules"
      :return-object="true"
      :hide-details="'auto'"
    >
      <template slot="no-data"> Nenhum Municipio retornado </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { municipioAPI } from "@/apis";

export default {
  name: "ComboMunicipios",
  props: {
    rules: {
      type: Array,
      default: () => {
        [];
      },
    },
    filter: {
      type: Object,
      default: () => {
        ({ municipioId: null });
      },
    },

    label: {
      type: String,
      default: "",
    },
    multiple: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },

  mounted() {
    this.load();
  },
  methods: {
    ...mapActions(["setLoading"]),

    load() {
      municipioAPI
        .list()
        .then(({ data }) => {
          this.municipios = data.data;
        })
        .catch((resp) => {
          this.$notification.error("Erro ao obter Municipios");
        });
    },
  },
  data() {
    return {
      municipios: [],
    };
  },
};
</script>

<style scoped>
/* .tema-eixo-combo {
  padding: 0 0 20px;
} */
</style>
